import { Grid, Typography } from "@mui/material";
import { GenericTable } from "~/components/GenericTable/GenericTable";
import { Fragment } from "react/jsx-runtime";
import { ReportsNoItemsSection } from "../../components";
import { useAssetReport } from "../hooks/useAssetReport";

interface ScoreDetailSectionProps<
  T extends keyof ReturnType<typeof useAssetReport>["scoreDetailsData"],
> {
  data: ReturnType<typeof useAssetReport>["scoreDetailsData"][T];
  children: React.ReactNode;
}

export function AssetReportScoreDetailSection<
  T extends keyof ReturnType<typeof useAssetReport>["scoreDetailsData"],
>({ data, children }: ScoreDetailSectionProps<T>) {
  return (
    <Grid container sx={{ alignItems: "flex-start", columnGap: 2, mb: 3 }}>
      <Grid
        size="grow"
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid size={12} sx={{ display: "flex", columnGap: 2 }}>
          <Typography sx={{ fontWeight: 700 }}>{data.title}</Typography>
          {data.sectionHighlights.map((highlight) => {
            const { options } = highlight ?? {};
            return (
              <Fragment key={highlight.key}>
                <Typography
                  sx={{
                    display: "flex",
                    gap: 0.5,
                    alignItems: "center",
                    fontWeight: options?.weight ?? 700,
                    color: options?.color ?? "text.secondary",
                  }}
                >
                  {highlight.startIcon && highlight.startIcon}
                  {highlight.value}
                </Typography>
              </Fragment>
            );
          })}
        </Grid>
        <Grid>
          <Typography variant="body2" color="text.secondary">
            {data.description}
          </Typography>
        </Grid>
      </Grid>
      <Grid size="auto">
        {/* <RiskBoxSmall riskLevel={"critical"} riskValue={4} /> */}
      </Grid>
      <Grid size={12} sx={{ mt: 3 }}>
        {data.listItems.length > 0 ? (
          <GenericTable
            items={0}
            tableName={data.tableName}
            validSortFields={[]}
            printView
          >
            {children}
          </GenericTable>
        ) : (
          <ReportsNoItemsSection
            target={
              data.title === "Vulnerabilities" ? "Vulnerabilities" : "Policies"
            }
          />
        )}
      </Grid>
    </Grid>
  );
}
